import { createApp } from 'vue'
import FormRadioGroup from './FormRadioGroup'

const el = '.kb-component--form-radio-group'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormRadioGroupDOM) => {
            const props = {
                type: FormRadioGroupDOM.dataset.type,
                tooltipText: FormRadioGroupDOM.dataset.tooltiptext,
                errorMessageLabel: FormRadioGroupDOM.dataset.errormessagelabel,
                helpMessageLabel: FormRadioGroupDOM.dataset.helpmessagelabel,
                placeholder: FormRadioGroupDOM.dataset.placeholder,
                label: FormRadioGroupDOM.dataset.label,
                legend: FormRadioGroupDOM.dataset.legend,
                isRequired: !!(FormRadioGroupDOM.dataset.isrequired === 'true'),
                fieldName: FormRadioGroupDOM.dataset.fieldname,
                radioOptions: JSON.parse(FormRadioGroupDOM.dataset.radiooptions),
                localValue: FormRadioGroupDOM.dataset.localValue,
            }
            const component = createApp(FormRadioGroup, props).use(Store)
            component.mount(FormRadioGroupDOM)
        })
    }
}
